import { LogIn } from 'lucide-react';
import { Button } from './Button';

interface LoginRequiredCardProps {
  title?: string;
  description?: string;
  buttonText?: string;
  onLoginClick: () => void;
}

export const LoginRequiredCard = ({ 
  title = 'Inicia sesión para ver esta sección',
  description = 'Accede a tu perfil, boletos y configuración',
  buttonText = 'Iniciar sesión',
  onLoginClick 
}: LoginRequiredCardProps) => {
  return (
    <div className="flex items-center justify-center min-h-[400px] p-4">
      <div className="max-w-md w-full bg-white rounded-[16px] border border-[#E5E7EB] shadow-sm p-8 text-center">
        {/* Icon */}
        <div className="w-16 h-16 bg-[#FFF4ED] rounded-full flex items-center justify-center mx-auto mb-4">
          <LogIn className="w-8 h-8 text-[#FF6A2A]" />
        </div>

        {/* Content */}
        <h2 className="text-xl font-bold text-[#111827] mb-2">
          {title}
        </h2>
        <p className="text-[#6B7280] mb-6">
          {description}
        </p>

        {/* CTA */}
        <Button
          onClick={onLoginClick}
          variant="primary"
          className="w-full"
        >
          {buttonText}
        </Button>
      </div>
    </div>
  );
};
